import { LineChart, Info } from "lucide-react";
import { LockedSection } from "@/components/plan/common";

function KpiCard({ kpi }) {
  return (
    <div className="bg-white border border-zinc-200 rounded-2xl p-4">
      <div className="flex justify-between items-baseline">
        <div className="font-medium text-sm">{kpi.metric}</div>
        <div className="text-indigo-600 font-display font-black">{kpi.target}</div>
      </div>
      <p className="text-xs text-zinc-500 mt-1">{kpi.why}</p>
      {kpi.assumption && (
        <div className="mt-2 flex items-start gap-1.5 text-[11px] text-zinc-500 bg-zinc-50 border border-zinc-100 rounded-md px-2 py-1.5">
          <Info className="h-3 w-3 mt-0.5 shrink-0 text-zinc-400" /> {kpi.assumption}
        </div>
      )}
    </div>
  );
}

export default function KpiSection({ dashboard, locked }) {
  if (!dashboard) return null;
  return (
    <LockedSection locked={locked} icon={LineChart} title="KPI dashboard">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <div className="text-xs uppercase tracking-widest text-zinc-500">Primary KPIs</div>
          <div className="mt-3 space-y-3">
            {dashboard.primary_kpis?.map((k, i) => <KpiCard key={`pk-${i}-${k.metric || ""}`} kpi={k} />)}
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-zinc-500">Secondary KPIs</div>
          <div className="mt-3 space-y-3">
            {dashboard.secondary_kpis?.map((k, i) => <KpiCard key={`sk-${i}-${k.metric || ""}`} kpi={k} />)}
          </div>
        </div>
      </div>
    </LockedSection>
  );
}
